import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ShareService } from '../../services/share.service';
import { ModalService } from '../../services/modal.service';
import { PdfExportService } from '../../services/pdf-export.service';
import { Space } from '../../models/space.model';

@Component({
    selector: 'app-spaces-overview',
    imports: [CommonModule, DatePipe, FormsModule, TranslateModule],
    templateUrl: './spaces-overview.component.html',
    styleUrl: './spaces-overview.component.scss'
})
export class SpacesOverviewComponent {
  @Input() spaces: Space[] = [];
  searchQuery = '';

  @Output() viewDetails = new EventEmitter<Space>();

  isExporting = false;

  constructor(
    private readonly shareService: ShareService,
    private readonly modalService: ModalService,
    private readonly pdfExportService: PdfExportService
  ) {}

  get filteredSpaces(): Space[] {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) {
      return this.spaces;
    }

    return this.spaces.filter(space =>
      space.name.toLowerCase().includes(query) ||
      space.ownerName.toLowerCase().includes(query)
    );
  }

  onViewDetails(space: Space): void {
    this.viewDetails.emit(space);
  }

  async exportPdf(space: Space): Promise<void> {
    if (this.isExporting) return;
    this.isExporting = true;
    try {
      await this.pdfExportService.exportSpaceAsHtml(space);
    } finally {
      this.isExporting = false;
    }
  }

  shareSpace(space: Space): void {
    this.shareService.shareSpace(space);
  }

  confirmDeleteSpace(space: Space): void {
    this.modalService.openDeleteSpaceModal(space.id);
  }
}
